import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { CollaboratoreDTO } from '../domain/collaboratore';
import { TenantDTO } from '../domain/tenant';
import { SondaggioRispostaOptionDTO } from './sondaggioRisposta';

export class SondaggioDTO extends LogicalDeleteDTO {
    id: number;
    tenant: TenantDTO;
    dataScadenza: Date;
    titolo: string;
    creatore: CollaboratoreDTO;
    descrizione: string;
    options: SondaggioOptionDTO[];
    risposte: SondaggioRispostaOptionDTO[];
    numMaxRisposte: number;
}

export class SondaggioOptionDTO extends LogicalDeleteDTO {
    id: number;
    name: string;
}